module.exports = __webpack_public_path__ + "static/img/zhongzhongka9.59f92e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhongzhongka9.png
// module id = 6aRC
// module chunks = 16